// src/Components/PWAInstall/PWAInstall.jsx

import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import './PWAInstall.css';

const PWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    // Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Check if user has dismissed before
      const isDismissed = localStorage.getItem('pwa-install-dismissed');
      const dismissedDate = localStorage.getItem('pwa-install-dismissed-date');
      
      // Show again after 7 days
      if (!isDismissed || (dismissedDate && Date.now() - parseInt(dismissedDate) > 7 * 24 * 60 * 60 * 1000)) {
        setShowInstallPrompt(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      
      setShowInstallPrompt(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    
    
    if (outcome === 'accepted') {
      
    }
    
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
    localStorage.setItem('pwa-install-dismissed', 'true');
    localStorage.setItem('pwa-install-dismissed-date', Date.now().toString());
  };

  if (!showInstallPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-banner">
      <div className="pwa-install-content">
        <div className="pwa-install-icon">
          <Download className="w-6 h-6 text-white" />
        </div>
        
        <div className="pwa-install-text">
          <h3 className="pwa-install-title">Install Bookizap</h3>
          <p className="pwa-install-description">
            Install our app for faster access and offline support!
          </p>
        </div>
        
        <div className="pwa-install-actions">
          <button onClick={handleInstallClick} className="pwa-install-btn">
            Install
          </button>
          <button onClick={handleDismiss} className="pwa-dismiss-btn">
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstall;
